import $ from 'jquery';

$(document).ready(function () {
  // Add selected class to the selected county
  const singleCountyMap = $('#single_county_map');
  const selectedCounty = singleCountyMap.data('selected');
  const selectedCountyPaths = $(`[id*=${selectedCounty}]`);
  selectedCountyPaths.addClass('selected');

  // Get the container width and height of .texas-svg-map
  const texasSvgMap = $('.texas-svg-map');
  const containerWidth = texasSvgMap.width();
  const containerHeight = texasSvgMap.height();

  // set offsets
  const xOffset = containerWidth / 5;
  const yOffset = containerHeight / 5;

  // Get the SVG element and its viewBox width
  const svgMap = $('.svg-map');
  const svgElement = $('#single_county_map svg');
  const viewBox = svgElement.attr('viewBox').split(' ');
  const viewBoxWidth = parseFloat(viewBox[2]);

  // Get the width of the .svg-map
  const svgMapWidth = svgMap.width();

  // use this to calculate the scale
  const scale = svgMapWidth / viewBoxWidth;

  // Find the position of the selected county using getBBox()
  const bbox = selectedCountyPaths[0].getBBox();
  const countyX = bbox.x;
  const countyY = bbox.y;
  const countyWidth = bbox.width;
  const countyHeight = bbox.height;

  // multiple all these by the scale to get the new position and size
  const newCountyX = countyX * scale;
  const newCountyY = countyY * scale;
  const newCountyWidth = countyWidth * scale;
  const newCountyHeight = countyHeight * scale;

  // center the selected county
  const translateX =
    containerWidth / 2 - (newCountyX + newCountyWidth / 2) + xOffset;
  const translateY =
    containerHeight / 2 - (newCountyY + newCountyHeight / 2) + yOffset;

  // apply the transformation to the .svg-map
  svgMap.css('transform', `translate(${translateX}px, ${translateY}px)`);

  // get the height and width of the .single-county-tooltip
  const singleCountyTooltip = $('.single-county-tooltip');
  const tooltipWidth = singleCountyTooltip.width();
  const tooltipHeight = singleCountyTooltip.height();

  // position the tooltip above the selected county
  const tooltipX = containerWidth / 2 - tooltipWidth / 2 + 15;
  const tooltipY =
    containerHeight / 2 - newCountyHeight / 2 - tooltipHeight / 2 + 20;

  singleCountyTooltip.css({
    left: tooltipX,
    top: tooltipY
  });
});
